import { Link } from 'react-router-dom'
import * as C from './styles.js'

export default function MoreOptions({ media_type, openMoreDetails, imdb_id, backgroundColor }) {
    return (
        <C.Container>
            <h2>Outras informações</h2>
            <C.Content backgroundColor={backgroundColor}>
                {media_type == 'tv' &&
                    <Link to={`?detalhes=temporadas`}>
                        <header>
                            <h3>Temporadas</h3>
                            <span><i className='fas fa-chevron-right'></i></span>
                        </header>
                        <main>
                            <span>Ver todas as temporadas</span>
                        </main>
                    </Link>
                }
                <Link to={`?detalhes=onde-assistir`}>
                    <header>
                        <h3>Onde Assistir?</h3>
                        <span><i className='fas fa-chevron-right'></i></span>
                    </header>
                    <main>
                        <span>Saiba onde assistir {media_type == 'tv' ? "esta série" : "este filme"}</span>
                    </main>
                </Link>
                <Link to={`?detalhes=imagens`}>
                    <header>
                        <h3>Imagens</h3>
                        <span><i className='fas fa-chevron-right'></i></span>
                    </header>
                    <main>
                        <span>Backdrops, logos e pôsteres</span>
                    </main>
                </Link>
                <Link to={`?detalhes=trailers`}>
                    <header>
                        <h3>Trailers</h3>
                        <span><i className='fas fa-chevron-right'></i></span>
                    </header>
                    <main>
                        <span>Trailers e teasers</span>
                    </main>
                </Link>
                <Link to={`?detalhes=producao`}>
                    <header>
                        <h3>Produção</h3>
                        <span><i className='fas fa-chevron-right'></i></span>
                    </header>
                    <main>
                        <span>Veja a equipe de produção</span>
                    </main>
                </Link>
                <Link to={`?detalhes=outras-informacoes`}>
                    <header>
                        <h3>Outras</h3>
                        <span><i className='fas fa-chevron-right'></i></span>
                    </header>
                    <main>
                        <span>Outras informações</span>
                    </main>
                </Link>
            </C.Content>
        </C.Container>
    )
}